export const REQUIRE_OPTION_CONFIG_CODE = 'designer_require_option'
export const REQUIRE_FIELD_CONFIG_CODE = 'designer_require_field'

const REQUIRE_CONFIG_IDENTITIES = {
  'form-check-in': {
    scopeKey: 'hosp-check-in',
    aliases: ['form-check-in'],
  },
  'form-eval-history-v31': {
    scopeKey: 'form-opd-eval-history-v31',
    aliases: [
      'form-eval-history-v31',
      'patient-evaluation-history-native',
      'form-screening',
    ],
  },
  'form-opd-eval-history-v31': {
    scopeKey: 'form-opd-eval-history-v31',
    aliases: [
      'form-eval-history-v31',
      'patient-evaluation-history-native',
      'form-screening',
    ],
  },
  'form-screening': {
    scopeKey: 'form-opd-eval-history-v31',
    aliases: [
      'form-eval-history-v31',
      'patient-evaluation-history-native',
      'form-screening',
    ],
  },
}

export const hasOwn = (value = {}, key) =>
  Object.prototype.hasOwnProperty.call(value || {}, key)

const unique = (values = []) => [...new Set(values.filter(Boolean))]

export const resolveRequireConfigIdentity = ({
  scopeKey,
  aliases = [],
  formCode,
} = {}) => {
  if (scopeKey) {
    return {
      scopeKey,
      aliases: unique(aliases).filter((alias) => alias !== scopeKey),
    }
  }

  if (!formCode) return { scopeKey: '', aliases: [] }

  const configuredIdentity = REQUIRE_CONFIG_IDENTITIES[formCode]
  if (configuredIdentity) return configuredIdentity

  return { scopeKey: formCode, aliases: [] }
}

const getConfigScope = (config = {}, scopeKey = '') =>
  config?.jsonData?.[scopeKey] || {}

const getFirstOwnValue = (source = {}, keys = []) => {
  for (const key of unique(keys)) {
    if (hasOwn(source, key)) {
      return { hasValue: true, value: Boolean(source[key]), key }
    }
  }

  return { hasValue: false, value: false, key: '' }
}

export const resolveRequiredValue = ({
  fieldKey,
  fieldAliases = [],
  scopeKey,
  aliases = [],
  pending = {},
  optionConfig = {},
  requireFieldConfig = {},
  systemRequired = false,
} = {}) => {
  const fieldKeys = unique([fieldKey, ...fieldAliases])
  const pendingValue = getFirstOwnValue(pending, fieldKeys)
  if (pendingValue.hasValue) {
    return { ...pendingValue, source: 'pending' }
  }

  const optionValue = getFirstOwnValue(
    getConfigScope(optionConfig, scopeKey),
    fieldKeys,
  )
  if (optionValue.hasValue) {
    return { ...optionValue, source: 'option' }
  }

  for (const configScopeKey of unique([scopeKey, ...aliases])) {
    const requireFieldValue = getFirstOwnValue(
      getConfigScope(requireFieldConfig, configScopeKey),
      fieldKeys,
    )
    if (requireFieldValue.hasValue) {
      return {
        ...requireFieldValue,
        source: 'requireField',
        scopeKey: configScopeKey,
      }
    }
  }

  return {
    hasValue: true,
    value: Boolean(systemRequired),
    key: fieldKey || '',
    source: systemRequired ? 'system' : 'default',
  }
}

export const isEmptyRequiredValue = (value, type = '') => {
  if (value === undefined || value === null) return true
  if (typeof value === 'boolean' || typeof value === 'number') return false
  if (Array.isArray(value)) return value.length === 0

  if (type === 'richText') {
    const textValue = String(value)
      .replace(/<br\s*\/?>/gi, '')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim()
    return textValue === ''
  }

  if (typeof value === 'object') return Object.keys(value).length === 0
  return String(value).trim() === ''
}

export const mergeRequireOptionConfig = ({
  config = {},
  scopeKey,
  pending = {},
} = {}) => ({
  ...config,
  configCode: REQUIRE_OPTION_CONFIG_CODE,
  jsonData: {
    ...(config.jsonData || {}),
    [scopeKey]: {
      ...(config?.jsonData?.[scopeKey] || {}),
      ...pending,
    },
  },
})
